import { withHTMLHeadSEO } from 'components/common';
import Launch from 'components/features/configuration/Launch';

const LaunchPage = () => <Launch />;

export default withHTMLHeadSEO({ title: 'Launch Page' })(LaunchPage);
